import { ErrorObject } from '@qpr/client-library/dist/esm/ErrorContext';
import axios, { AxiosError, AxiosResponse } from 'axios';
import { useQuery } from 'react-query';

export interface Data {
  _id: string;
  title: string;
  enabled: boolean;
  description?: string;
  group?: string | null;
  link: string;
  icon?: string | JSX.Element;
  children: Data[];
  rangecolor?: string;
}

const useNavitems = (path?: string[]) =>
  useQuery<AxiosResponse<Data>, AxiosError<ErrorObject>>(`navitems`, async () => {
    const response = await axios.get<AxiosResponse<Data>>('navitems');

    if (path) {
      const search = (n: Data | null): Data | null => {
        if (n) {
          if (n.title.toLowerCase() === path[0].toLowerCase()) {
            return n;
          }
          if (n.children && n.children.length > 0) {
            n.children.forEach(e => {
              const childResult = search(e);
              if (childResult) {
                return childResult;
              }
            });
          }
        }
        return null;
      };

      const found = search(response.data?.data);
      //      const filteredData = found ? [found] : [];

      if (found) {
        response.data.data = found;
      }
    }

    return response.data;
  });

export default useNavitems;
